module.exports = __webpack_public_path__ + "img/how-to-download.5fbe8b5b.gif";